import { Navigate, useRoutes } from "react-router-dom";
// layouts
import DashboardLayout from "./layouts/dashboard";
import SimpleLayout from "./layouts/simple";
//
import BlogPage from "./pages/BlogPage";
import GamePage from "./pages/GamePage";
import UserPage from "./pages/UserPage";
import LoginPage from "./pages/LoginPage";
import Page404 from "./pages/Page404";
import ProductsPage from "./pages/ProductsPage";
import DashboardAppPage from "./pages/DashboardAppPage";
import NewGamePage from "./pages/NewGamePage";
import GameQuestionsPage from "./pages/GameQuestionsPage";
import GameUsersPage from "./pages/GameUsersPage";
import GameUserCardPage from "./pages/GameUserCardPage";
import PickemEditPage from "./pages/PickemEditPage";
import GameQuestionCreatePage from "./pages/GameQuestionCreatePage";
import PickemQuestinPage from "./pages/PickemQuestionPage";
import ImageLibraryPage from "./pages/ImageLibraryPage";
import BannersPage from './pages/BannersPage';
import LeaderboardsPage from "./pages/LeaderboardsPage";
import LeaderboardPage from "./pages/LeaderboardPage";
import UserSelectionsPage from "./pages/UserSelectionsPage";
import LeaguesPage from "./pages/LeaguesPage";
import LeagueTournamentsPage from "./pages/LeagueTournamentsPage";
import PlayersStatsPage from "./pages/PlayersStatsPage";
import FriendsLeaguePage from "./pages/FriendsLeaguePage";
import FixturesGoaliePage from "./pages/FixturesGoaliePage";
import PagesList from "./pages/PagesList";
import PageEditPage from "./pages/PageEditPage";

// ----------------------------------------------------------------------

export default function Router() {
  const routes = useRoutes([
    {
      path: "/dashboard",
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/dashboard/pickems" />, index: true },
        { path: "pickems", element: <GamePage /> },
        { path: "pages", element: <PagesList /> },
        { path: "pages/edit", element: <PageEditPage /> },
        { path: "image-library", element: <ImageLibraryPage /> },
        { path: "banners", element: <BannersPage /> },
        { path: "leaderboards", element: <LeaderboardsPage /> },
        { path: "leaderboards/view", element: <LeaderboardPage /> },
        { path: "user-selections", element: <UserSelectionsPage /> },
        { path: "leagues", element: <LeaguesPage /> },
        { path: "friends-leagues", element: <FriendsLeaguePage /> },
        { path: "league-tournaments", element: <LeagueTournamentsPage /> },
        { path: "new-game", element: <NewGamePage /> },
        { path: "pickem/edit", element: <PickemEditPage /> },
        { path: "pickem/question", element: <PickemQuestinPage /> },
        { path: "stats", element: <PlayersStatsPage /> },
        { path: "fixtures-squad", element: <FixturesGoaliePage /> },
        { path: "game/questions", element: <GameQuestionsPage /> },
        { path: "game/questions/create", element: <GameQuestionCreatePage /> },
        { path: "game/users", element: <GameUsersPage /> },
        { path: "game/user-card", element: <GameUserCardPage /> },
        { path: "app", element: <DashboardAppPage /> },
        { path: "user", element: <UserPage /> },
        { path: "products", element: <ProductsPage /> },
        { path: "blog", element: <BlogPage /> },
      ],
    },
    {
      path: "login",
      element: <LoginPage />,
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/dashboard/pickems" />, index: true },
        { path: "404", element: <Page404 /> },
        { path: "*", element: <Navigate to="/404" /> },
      ],
    },
    {
      path: "*",
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
